export enum Branch {
  None = "None",
  SparePartReplenishment = "Spare Part Replenishment",
}
